class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.closeMenuDelay = null;

    this.enableDesktopHoverOpen = this.summary?.dataset.menuOpenOnHover === 'true';
    this.enableDesktopClickNavigate = this.summary?.dataset.menuClickNavigate === 'true';
    this.parentMenuUrl = this.summary?.dataset.menuParentUrl;

    if (this.enableDesktopHoverOpen) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onDesktopMouseEnter.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.onDesktopMouseLeave.bind(this));
    }

    if (this.enableDesktopClickNavigate && this.parentMenuUrl) {
      this.summary.addEventListener('click', this.onDesktopSummaryClick.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onDesktopMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeMenuDelay);
    this.closeOtherOpenMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  onDesktopMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeMenuDelay);
    this.closeMenuDelay = window.setTimeout(() => {
      this.close();
      this.onToggle();
    }, 120);
  }

  onDesktopSummaryClick(event) {
    if (!this.desktopMediaQuery.matches) return;
    if (!this.parentMenuUrl || this.parentMenuUrl === '#') return;

    event.preventDefault();
    window.location.href = this.parentMenuUrl;
  }

  closeOtherOpenMenus() {
    const menuList = this.mainDetailsToggle.closest('.list-menu');
    if (!menuList) return;

    menuList.querySelectorAll('header-menu').forEach((menuDisclosure) => {
      if (menuDisclosure === this) return;
      menuDisclosure.close();
      if (menuDisclosure.onToggle) menuDisclosure.onToggle();
    });
  }
}

customElements.define('header-menu', HeaderMenu);
